import Phaser from 'phaser';

import { BlackjackMainScene } from '../../scenes/blackjack-main-scene';
import { Subscription } from 'rxjs';
import { ResizeMetrics } from '../../model/resize-metrics';
import { Blackjack, GameEvent } from 'game-logic';
import { RoundedLabelView } from '../components/rounded-label-view';
import { CroupierHandViewModel } from './croupier-hand-view-model';
import { CroupierCardStackView } from './croupier-card-stack-view';

export class CroupierHandView extends Phaser.GameObjects.Container {
  private currentResizeMetrics?: ResizeMetrics;
  private subscriptionGroup: Subscription;

  private croupierCardStackView: CroupierCardStackView;
  private croupierScoreView: RoundedLabelView;

  constructor(
    scene: BlackjackMainScene,
    x: number,
    y: number,
    private viewModel: CroupierHandViewModel,
  ) {
    super(scene, x, y);

    this.subscriptionGroup = new Subscription();

    this.croupierCardStackView = new CroupierCardStackView(
      scene,
      0,
      0,
      viewModel.croupierCardStackViewModel,
    );
    this.add(this.croupierCardStackView);

    this.croupierScoreView = new RoundedLabelView(scene, 0, 0, viewModel.croupierScoreViewModel);
    this.add(this.croupierScoreView);

    this.setName(CroupierHandView.name);
    scene.add.existing(this);

    this.subscriptionGroup.add(
      viewModel.logicEventQueue$.subscribe((eventQueue) => {
        eventQueue?.subscribe(this.handleLogicEvents.bind(this));
      }),
    );
    this.subscriptionGroup.add(
      viewModel.scoreText$.subscribe((text) => {
        this.croupierScoreView.setVisible(text.length > 0);
      }),
    );
  }

  override destroy(fromScene?: boolean | undefined): void {
    this.subscriptionGroup.unsubscribe();

    super.destroy(fromScene);
  }

  public onResize(resizeMetrics: ResizeMetrics) {
    this.croupierCardStackView?.onResize(resizeMetrics);
    this.croupierScoreView?.onResize(resizeMetrics);

    this.currentResizeMetrics = resizeMetrics;
    this.refreshLayout();
  }

  private refreshLayout(): void {
    if (!this.currentResizeMetrics) {
      return;
    }
    const layoutConfig = this.currentResizeMetrics.layoutConfig;
    const scalingMetrics = this.currentResizeMetrics.scalingMetrics;

    const boxScale = 0.8;
    const controlsWidth = layoutConfig.bettingBoxWidth * boxScale * scalingMetrics.scaleFactor;
    const controlsHeight = layoutConfig.bettingBoxHeight * boxScale * scalingMetrics.scaleFactor;

    this.setSize(controlsWidth, controlsHeight);

    this.croupierCardStackView.setPosition(0, 0);

    const padding = layoutConfig.paddingSm * scalingMetrics.scaleFactor;
    this.croupierScoreView.setY(
      (controlsHeight + this.croupierScoreView.displayHeight) * 0.5 + padding,
    );
  }

  private async handleLogicEvents(event: GameEvent<Blackjack.BlackjackEvents>): Promise<void> {
    // Don't process instant events
    if (event.instant) {
      return;
    }

    switch (event.type) {
      case 'onDrawDeckCroupier':
        this.viewModel.updateScore(event.payload.croupier);
        break;
      case 'onDrawDeckCroupierHidden':
        break;
      case 'onRevealDeckCroupier':
        this.viewModel.updateScore(event.payload.croupier);
        break;
      case 'onCroupierCleared':
        this.viewModel.clearScore();
        break;
      default:
        break;
    }
  }
}
